import { Suspense } from 'react';
import { Container } from 'reactstrap';

import Footer from '#components/Footer';

import LeftSidebar from './components/left-sidebar/left-sidebar.view';
import Topbar from './components/topbar/topbar.view';
import useVerticalLayoutController from './vertical-layout.controller';
import styles from './vertical-layout.module.scss';

const emptyLoading = () => <div />;
const loading = () => <div className="text-center" />;

export default function VerticalLayoutView(props) {
    const { children, isCondensed, isMobileMenuOpen, openLeftMenu, closeMobileMenu } =
        useVerticalLayoutController(props);

    return (
        <div className="app">
            <div className="wrapper">
                {isMobileMenuOpen ? (
                    <button
                        type="button"
                        className={styles.mobileBackdrop}
                        aria-label="Close navigation menu"
                        onClick={closeMobileMenu}
                    />
                ) : null}

                <Suspense fallback={emptyLoading()}>
                    <LeftSidebar
                        isCondensed={isCondensed}
                        isMobileOpen={isMobileMenuOpen}
                        onCloseMobileMenu={closeMobileMenu}
                    />
                </Suspense>

                <div className="content-wrapper">
                    <div className="content-page">
                        <div className="content">
                            <Suspense fallback={emptyLoading()}>
                                <Topbar openLeftMenuCallBack={openLeftMenu} />
                            </Suspense>

                            <Container fluid>
                                <Suspense fallback={loading()}>{children}</Suspense>
                            </Container>
                        </div>
                    </div>

                    <Suspense fallback={emptyLoading()}>
                        <Footer />
                    </Suspense>
                </div>
            </div>
        </div>
    );
}
